export default {
    keyWord : (state)=>{return state.keyWord}
}


// WEBPACK FOOTER //
// ./src/store/getters.js